var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "sms",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_26",
    "data-name": 26
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.814 507.555a26.44 26.44 0 0 1 -26.314-27.435l6.571-186.434v-.11a26.212 26.212 0 0 1 19.749-24.417 15.947 15.947 0 0 1 3.1-.482l225.639-12.677-225.63-12.677a15.947 15.947 0 0 1 -3.1-.482 26.212 26.212 0 0 1 -19.749-24.417v-.11l-6.58-186.434a26.361 26.361 0 0 1 38.132-24.615l450.315 225.157a26.361 26.361 0 0 1 0 47.156l-450.315 225.157a26.371 26.371 0 0 1 -11.818 2.82zm12.049-207.329-6.05 171.642 431.736-215.868-431.736-215.868 6.05 171.642 324.262 18.219a16.025 16.025 0 0 1 3.1.483 26.36 26.36 0 0 1 0 51.048 16.025 16.025 0 0 1 -3.1.483z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.b0bb8fbef7c32583c6b31206465cd7c7.svg";
export { ForwardRef as ReactComponent };